import Splide from '@splidejs/splide';

export const initWhereInstalledSlider = () => {
  new Splide('[data-smart-lighting-control-where-installed-slider]', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    classes: {
      pagination: 'smart-lighting-control-where-installed__slider-pagination',
      page: 'smart-lighting-control-where-installed__slider-pagination-btn',
    },
  }).mount();
};
